// extracted by mini-css-extract-plugin
export var acceptButton = "_3l-5";
export var fullContent = "_3l-4";
export var link = "_3l-6";
export var linkIcon = "_3l-7";
export var sideContent = "_3l-3";
export var sideImage = "_3l-2";
export var sideImageWrapper = "_3l-1";
export var splitLayout = "_3l-0";